import { createFileRoute } from '@tanstack/react-router';
import { ReceiptDetailPanel } from '@/components/organisms/receipts/ReceiptDetailPanel';

export const Route = createFileRoute('/_dashboard/dashboard/receipts/$id')({
  component: ReceiptDetailPage,
});

function ReceiptDetailPage() {
  const { id } = Route.useParams();

  return <ReceiptDetailPanel id={id} />;
}
